<template>
  <div id="app">
    <TopBarV2 />
    <router-view />
    <FootBarV2 />
  </div>
</template>

<script>
import TopBarV2 from '@/components/TopBarV2.vue'
import FootBarV2 from '@/components/FootBarV2.vue'

export default {
  components: {
    TopBarV2,
    FootBarV2
  }
}
</script>
